/**
 * buy_service_models 中文文案 → 英/日/繁 对照（键与数据源完全一致，含换行）。
 * 新增套餐文案时请同步补充；可用 `node scripts/extract-service-buy-locale.mjs` 核对唯一字符串列表。
 */
type Triple = { en: string; ja: string; zhTW: string }

function T(zh: string, en: string, ja: string, zhTW: string): [string, Triple] {
  return [zh, { en, ja, zhTW }]
}

const rows: [string, Triple][] = [
  T('AI写作及百科问答', 'AI writing & Q&A', 'AIライティング・百科Q&A', 'AI寫作及百科問答'),
  T('AI自由写作，百问百答', 'Free-form AI writing with answers to all questions', 'AIによる自由記述と百問百答', 'AI自由寫作，百問百答'),
  T('C盘瘦身专家', 'C: drive cleanup', 'Cドライブクリーンアップ', 'C槽瘦身專家'),
  T('IP访问限制', 'IP access restriction', 'IPアクセス制限', 'IP存取限制'),
  T('PDF文档格式转换', 'PDF format conversion', 'PDF形式変換', 'PDF文件格式轉換'),
  T('PDF编辑', 'PDF editing', 'PDF編集', 'PDF編輯'),
  T(
    'PDF编辑工具，如批注，高亮文本，提取页面，修改文字等',
    'PDF tools: annotations, highlights, page extraction, text edits, and more',
    '注釈・ハイライト・ページ抽出・文字修正などのPDF編集機能',
    'PDF編輯工具，如註解、醒目提示文字、擷取頁面、修改文字等',
  ),
  T('PPT/EXCEL/WORLD模版', 'PPT / Excel / Word templates', 'PPT・Excel・Wordテンプレート', 'PPT/EXCEL/WORD範本'),
  T(
    'USB外接设备管控',
    'USB peripheral control',
    'USB外部機器の管理',
    'USB外接裝置管控',
  ),
  T('上网管控服务', 'Internet access control services', 'インターネット利用管理サービス', '上網管控服務'),
  T(
    '企业正版化合规保障组合',
    'Genuine software compliance bundle',
    '正規ライセンスコンプライアンスパック',
    '企業正版化合規保障組合',
  ),
  T(
    '体检内容包含电脑速度、系统异常、病毒木马、电脑垃\n圾、电脑防护、软件净化，并支持对终端进行批量体检',
    'Health checks cover PC speed, system issues, malware, junk files, protection, and software cleanup, with batch scans on endpoints.',
    '診断はPC速度・システム異常・ウイルス・ゴミファイル・保護・ソフト浄化を含み、端末の一括診断に対応。',
    '體檢內容包含電腦速度、系統異常、病毒木馬、電腦垃圾、電腦防護、軟體淨化，並支援對終端進行批次體檢',
  ),
  T(
    '保障企业数据安全边界，精准管控和防护核心数据流转',
    'Protect data boundaries and control critical data flows.',
    'データ境界を守り、重要データの流れを厳密に管理・保護。',
    '保障企業資料安全邊界，精準管控與防護核心資料流轉',
  ),
  T(
    '全面守护终端，重点管控、审计所有终端的上网和软件、外设使用行为',
    'Protect all endpoints; govern and audit web, software, and peripheral usage.',
    '全端末を保護し、ネット・ソフト・周辺機器の利用を重点管理・監査。',
    '全面守護終端，重點管控、稽核所有終端的上網與軟體、外設使用行為',
  ),
  T('办公效率服务', 'Office productivity services', 'オフィス生産性サービス', '辦公效率服務'),
  T('勒索防护', 'Ransomware protection', 'ランサムウェア対策', '勒索防護'),
  T(
    '协助企业营造合规正版化办公环境，满足正版化合规监管要求',
    'Help build a compliant, genuine-software workplace to meet regulatory requirements.',
    '正規ライセンスに準拠した職場環境の構築を支援し、監督要件に対応。',
    '協助企業營造合規正版化辦公環境，滿足正版化合規監管要求',
  ),
  T(
    '发现企业内网未安装毒霸企业版的终端设备。',
    'Discover endpoints on the intranet without the enterprise endpoint client installed.',
    'イントラネット上でエンタープライズ版未導入の端末を検出。',
    '發現企業內網未安裝毒霸企業版的終端裝置。',
  ),
  T(
    '可批量开启勒索防护和生成诱饵文件、实时监测风险行为，及时进行阻断，并支持多维度查看勒索风险事件',
    'Enable ransomware protection and decoys in bulk, monitor risky behavior in real time, block threats, and view incidents from multiple dimensions.',
    'ランサム対策とおとりファイルを一括有効化し、リスク行動をリアルタイム監視・遮断、多角的にイベントを確認。',
    '可批次開啟勒索防護並產生誘餌檔案、即時監測風險行為並及時阻斷，並支援多維度檢視勒索風險事件',
  ),
  T(
    '可批量阻断多台终端自定义端口，并提供多维度统计和管控功能',
    'Block custom ports on many endpoints in bulk, with multi-dimensional stats and controls.',
    '複数端末の任意ポートを一括ブロックし、多次元の集計・管理機能を提供。',
    '可批次阻斷多台終端自訂連接埠，並提供多維度統計與管控功能',
  ),
  T(
    '可支持下发特定的文件，如文档、可执行文件、脚本文件',
    'Distribute specific files such as documents, executables, and scripts.',
    '文書・実行ファイル・スクリプトなど特定ファイルの配信に対応。',
    '可支援下發特定檔案，如文件、可執行檔、指令碼檔',
  ),
  T(
    '可设置水印显示信息和水印模式，支持隐性水印和显性水印，对于截屏、拍照等泄露方式可追溯泄露源',
    'Configure watermark content and modes, including covert and visible watermarks, to trace leaks from screenshots or photos.',
    '透かしの内容・モードを設定。隠し／可視の透かしに対応し、スクショ・撮影から漏えい元を追跡。',
    '可設定浮水印顯示資訊與模式，支援隱性與顯性浮水印，對截圖、拍照等外洩方式可追溯來源',
  ),
  T('图片浏览编辑', 'Image viewing & editing', '画像の閲覧・編集', '圖片瀏覽編輯'),
  T('域名访问限制', 'Domain access restriction', 'ドメインアクセス制限', '網域存取限制'),
  T(
    '基于金山毒霸20+年安全技术积累\n提供基础终端安全防护与管理服务',
    'Built on 20+ years of security expertise\nDelivers foundational endpoint protection and management.',
    '20年以上のセキュリティ技術の蓄積に基づく\n基礎的な端末セキュリティと管理サービス。',
    '基於金山毒霸20+年安全技術積累\n提供基礎終端安全防護與管理服務',
  ),
  T('基础安全防护组合', 'Basic security protection bundle', '基本セキュリティ保護パック', '基礎安全防護組合'),
  T('基线扫描', 'Baseline scanning', 'ベースラインスキャン', '基線掃描'),
  T(
    '多格式转换，转WORD/EXCEL/PPT,高效办公，一键批量转换，无大小限制，超大文档任意转',
    'Multi-format conversion to Word/Excel/PPT—one-click batch jobs, no size limits, even huge files.',
    'WORD/EXCEL/PPTへの多形式変換。一括変換、サイズ制限なし、超大容量も対応。',
    '多格式轉換，轉WORD/EXCEL/PPT，高效辦公，一鍵批次轉換，無大小限制，超大文件任意轉',
  ),
  T(
    '对团队内终端设备下发软件禁用策略，同时支持软件黑白名单属性管理',
    'Push software block policies to team endpoints with allow/deny list management.',
    'チーム端末にソフト無効化ポリシーを配信し、ホワイト/ブラックリスト管理に対応。',
    '對團隊內終端裝置下發軟體停用原則，同時支援軟體黑白名單屬性管理',
  ),
  T(
    '对团队内终端设备进行正版软件授权并限制未授权的终端使用，并支持团队内授权终端数量分析',
    'License genuine software per endpoint, block unauthorized use, and analyze licensed device counts.',
    '端末ごとに正規ライセンスを付与し未許可利用を制限、許可台数の分析に対応。',
    '對團隊內終端裝置進行正版軟體授權並限制未授權的終端使用，並支援團隊內授權終端數量分析',
  ),
  T(
    '对团队内终端设备镜像基线安全扫描与立即修复',
    'Run baseline security scans on team endpoints with immediate remediation.',
    'チーム端末にベースラインセキュリティスキャンと即時修復を実施。',
    '對團隊內終端裝置進行基線安全掃描與立即修復',
  ),
  T(
    '展示团队内所有终端设备的软件使用统计情况，支持软\n件视图、终端视图维度',
    'Show software usage stats across endpoints by software view or endpoint view.',
    '全端末のソフト利用統計を表示。ソフトビュー／端末ビューに対応。',
    '展示團隊內所有終端裝置的軟體使用統計，支援軟體檢視、終端檢視維度',
  ),
  T(
    '展示漏洞涉及的终端数量与未处理的漏洞数量，并支持\n一键修复与忽略',
    'Show affected endpoints and open vulnerabilities, with one-click fix or ignore.',
    '脆弱性の影響端末数・未処理数を表示。一括修復・無視に対応。',
    '展示漏洞涉及的終端數量與未處理的漏洞數量，並支援一鍵修復與忽略',
  ),
  T('广告弹窗拦截', 'Ad & pop-up blocking', '広告・ポップアップのブロック', '廣告彈窗攔截'),
  T(
    '快速恢复误删除、格式化、分区表损坏、磁盘变RAW等情况下丢失的文档、视频、邮件、照片、音乐等，支持先预览再恢复',
    'Recover lost documents, videos, mail, photos, and music after deletion, format, partition damage, or RAW disks—preview before restore.',
    '削除・フォーマット・パーティション破損・RAW化などから文書・動画・メール・写真・音楽を復元。プレビュー後に復元可能。',
    '快速復原誤刪除、格式化、分割區表損壞、磁碟變RAW等情況下遺失的文件、影片、郵件、照片、音樂等，支援先預覽再復原',
  ),
  T(
    '快速释放系统磁盘空间，提升电脑运行速度',
    'Free disk space quickly to improve PC performance.',
    'ディスク容量を素早く解放し、PCの動作を高速化。',
    '快速釋放系統磁碟空間，提升電腦執行速度',
  ),
  T(
    '拦截各类客户端软件骚扰广告弹窗，支持桌面任意位置、桌面图标等各骚扰弹窗类型',
    'Block intrusive ads and pop-ups from desktop apps, anywhere on the desktop including icons.',
    'デスクトップ上のあらゆる位置・アイコンなど、各種ポップアップ広告をブロック。',
    '攔截各類用戶端軟體騷擾廣告彈窗，支援桌面任意位置、桌面圖示等各騷擾彈窗類型',
  ),
  T('提供大量免费模版', 'Large library of free templates', '豊富な無料テンプレート', '提供大量免費範本'),
  T(
    '支持内置或自定义敏感词及文件格式配置，能够对企业内部的敏感文件进行扫描和生命周期监控。外发敏感文件时可进行审批或直接阻断，以确保数据安全；',
    'Built-in or custom sensitive keywords and file types; scan and monitor sensitive files. Approve or block outbound sensitive files to keep data safe.',
    '組み込みまたはカスタムの機密キーワード・ファイル形式。機密ファイルのスキャンとライフサイクル監視。外部送信時は承認またはブロック。',
    '支援內建或自訂敏感詞及檔案格式設定，可對企業內部敏感檔案掃描與生命週期監控。外傳敏感檔案時可審批或直接阻斷，以確保資料安全；',
  ),
  T(
    '支持对终端进行批量闪电查杀、全盘查杀及定时查杀设\n置，并支持全面文件类型查杀和自动更新病毒库',
    'Batch quick scan, full scan, and scheduled scans; all file types supported with automatic signature updates.',
    '一括クイックスキャン・全スキャン・定期スキャン。全ファイルタイプ対応、ウイルス定義の自動更新。',
    '支援對終端進行批次快速掃毒、全盤掃毒及排程掃毒設定，並支援全面檔案類型掃毒與自動更新病毒庫',
  ),
  T(
    '支持对终端进行流量限速，可按时间段限制上传速度和下载速度',
    'Throttle endpoint traffic with time-based upload/download limits.',
    '端末のトラフィックを時間帯別にアップロード・ダウンロード速度制限。',
    '支援對終端進行流量限速，可依時段限制上傳與下載速度',
  ),
  T(
    '支持对进出站网络数据包实施规则化管控，支持依据目标IP、端口号、协议类型自定义过滤规则',
    'Rule-based control of inbound/outbound packets with custom filters by IP, port, and protocol.',
    '送受信パケットをルールで制御。宛先IP・ポート・プロトコルでカスタムフィルタ。',
    '支援對進出站網路封包實施規則化管控，可依目標IP、連接埠號、通訊協定類型自訂過濾規則',
  ),
  T(
    '支持控制台远程操作团队终端，对于非控制台远程登录时可触发二次认证（密码 + 动态口令等多重核验），防范密码泄露导致的远程非法入侵。',
    'Remote control from the console; non-console remote logins can require MFA (password + OTP) to prevent credential abuse.',
    'コンソールからの遠隔操作。コンソール外ログイン時はMFA（パスワード＋ワンタイム等）で不正侵入を防止。',
    '支援主控台遠端操作團隊終端，對非主控台遠端登入可觸發二次驗證（密碼+動態口令等多重核驗），防範密碼外洩導致的遠端非法入侵。',
  ),
  T(
    '支持终端设备视图、软件视图查看软件的安装情况，同时\n支持软件批量安装、远程卸载、软件安装情况数据导出',
    'View installs by device or software; batch install, remote uninstall, and export install reports.',
    '端末ビュー／ソフトビューで導入状況を確認。一括インストール・遠隔アンインストール・エクスポートに対応。',
    '支援終端裝置檢視、軟體檢視查看軟體的安裝情況，同時支援軟體批次安裝、遠端解除安裝、安裝情況資料匯出',
  ),
  T(
    '支持音频MP3、FLAC、WAV、M4A等多种格式互转以\n及视频MP4、AVI、MOV等多种格式互转，同时支持视频转换。',
    'Convert audio (MP3, FLAC, WAV, M4A, etc.) and video (MP4, AVI, MOV, etc.) across formats.',
    'MP3/FLAC/WAV/M4Aなどの音声、MP4/AVI/MOVなどの動画の相互変換に対応。',
    '支援音訊MP3、FLAC、WAV、M4A等多種格式互轉以及影片MP4、AVI、MOV等多種格式互轉，同時支援影片轉換。',
  ),
  T('数据外发管控', 'Outbound data control', 'データ外部送信の管理', '資料外發管控'),
  T('数据安全服务', 'Data security services', 'データセキュリティサービス', '資料安全服務'),
  T('数据安全防护组合', 'Data security protection bundle', 'データセキュリティ保護パック', '資料安全防護組合'),
  T('数据恢复', 'Data recovery', 'データ復元', '資料復原'),
  T('文件/软件分发', 'File / software distribution', 'ファイル・ソフトウェア配信', '檔案/軟體分發'),
  T('文件分发', 'File distribution', 'ファイル配信', '檔案分發'),
  T(
    '显示团队内的终端设备信息，支持分组管理',
    'Show endpoint inventory for the team with group management.',
    'チーム内端末情報を表示し、グループ管理に対応。',
    '顯示團隊內的終端裝置資訊，支援分群管理',
  ),
  T(
    '显示团队内的终端设备允许状态及预警，涵盖运行\nCPU、内存、系统盘占用、网速占用与温度情况',
    'Show endpoint health and alerts: CPU, memory, system disk, network usage, and temperature.',
    '端末の稼働状態とアラートを表示。CPU・メモリ・システムディスク・ネットワーク・温度を網羅。',
    '顯示團隊內的終端裝置允許狀態及預警，涵蓋執行中CPU、記憶體、系統碟佔用、網速佔用與溫度情況',
  ),
  T('桌管运维组合', 'Desktop management & O&M bundle', 'デスクトップ管理・運用パック', '桌管維運組合'),
  T(
    '正版软件授权及分析',
    'Genuine software licensing & analytics',
    '正規ソフトウェアのライセンスと分析',
    '正版軟體授權及分析',
  ),
  T(
    '涵盖数据恢复、勒索损失、信息泄露、应急响应等多场景赔付，最高赔付50万',
    'Covers data recovery, ransomware loss, data breach, emergency response, and more—up to ¥500,000 coverage.',
    'データ復元・ランサム損失・情報漏えい・緊急対応など複数シーン、最高50万元補償。',
    '涵蓋資料復原、勒索損失、資訊外洩、緊急應變等多場景賠付，最高賠付50萬',
  ),
  T('漏洞扫描修复', 'Vulnerability scan & fix', '脆弱性スキャンと修復', '漏洞掃描修復'),
  T('病毒木马查杀', 'Malware detection & removal', 'ウイルス・マルウェアの検出と除去', '病毒木馬查殺'),
  T(
    '禁用USB外设或只允许特定USB设备使用，支持对USB外设审批',
    'Disable USB devices or allow only approved devices, with USB approval workflows.',
    'USBを無効化または特定デバイスのみ許可。USB利用の承認フローに対応。',
    '停用USB外設或只允許特定USB裝置使用，支援對USB外設審批',
  ),
  T(
    '禁用团队内终端设备访问特定的域名，支持黑白名单属性',
    'Block or allow specific domains on team endpoints with allow/deny lists.',
    'チーム端末の特定ドメインアクセスを禁止。ホワイト/ブラックリストに対応。',
    '停用團隊內終端裝置存取特定網域名稱，支援黑白名單屬性',
  ),
  T('程序运行控制', 'Application execution control', 'プログラム実行の制御', '程式執行控制'),
  T('端口管控', 'Port control', 'ポート管理', '連接埠管控'),
  T('终端优化服务', 'Endpoint optimization services', 'エンドポイント最適化サービス', '終端最佳化服務'),
  T('终端发现', 'Endpoint discovery', 'エンドポイントの検出', '終端探索'),
  T('终端安全体检', 'Endpoint security health check', 'エンドポイントセキュリティ診断', '終端安全體檢'),
  T('终端安全服务', 'Endpoint security services', 'エンドポイントセキュリティサービス', '終端安全服務'),
  T('终端流量管控', 'Endpoint traffic control', 'エンドポイントトラフィック管理', '終端流量管控'),
  T('终端状态监控及预警', 'Endpoint status monitoring & alerts', 'エンドポイント状態の監視と警告', '終端狀態監控及預警'),
  T('终端设备管理', 'Endpoint device management', 'エンドポイント端末管理', '終端裝置管理'),
  T('终端运维服务', 'Endpoint O&M services', 'エンドポイント運用サービス', '終端維運服務'),
  T(
    '网安E保-网络完全保障险',
    'Cyber Security E-Policy (network security insurance)',
    'サイバーセキュリティE保険（ネットワーク安全保障）',
    '網安E保－網路安全保障險',
  ),
  T('资产管理服务', 'Asset management services', '資産管理サービス', '資產管理服務'),
  T(
    '软件使用统计分析',
    'Software usage statistics & analytics',
    'ソフトウェア利用統計・分析',
    '軟體使用統計分析',
  ),
  T('软件禁用', 'Software blocking', 'ソフトウェアの無効化', '軟體停用'),
  T('软件管理', 'Software management', 'ソフトウェア管理', '軟體管理'),
  T(
    '远程桌面与二次认证',
    'Remote desktop & secondary authentication',
    'リモートデスクトップと二要素認証',
    '遠端桌面與二次驗證',
  ),
  T(
    '通过进程名、进程路径、进程MD5、数字签名禁止团队内终端设备进程运行',
    'Block processes by name, path, MD5, or digital signature on team endpoints.',
    'プロセス名・パス・MD5・署名でチーム端末のプロセス実行を禁止。',
    '透過處理序名稱、處理序路徑、處理序MD5、數位簽章禁止團隊內終端裝置處理序執行',
  ),
  T(
    '隐性/显性水印管理',
    'Covert / visible watermark management',
    '隠し／可視透かしの管理',
    '隱性/顯性浮水印管理',
  ),
  T('音视频格式转换', 'Audio & video format conversion', '音声・動画の形式変換', '音視訊格式轉換'),
  T(
    '高级图片处理，速度快，超多格式支持，图片转PDF、尺寸修改、图片压缩、文字识别、高级打印、图片美化',
    'Advanced image tools: fast, many formats, image to PDF, resize, compress, OCR, advanced print, beautify.',
    '高機能画像処理：高速・多形式、画像→PDF、リサイズ、圧縮、OCR、高品質印刷、補正。',
    '進階圖片處理，速度快，超多格式支援，圖片轉PDF、尺寸修改、圖片壓縮、文字辨識、進階列印、圖片美化',
  ),
]

export const SERVICE_BUY_ZH_TO_EN: Record<string, string> = Object.fromEntries(
  rows.map(([zh, v]) => [zh, v.en]),
)
export const SERVICE_BUY_ZH_TO_JA: Record<string, string> = Object.fromEntries(
  rows.map(([zh, v]) => [zh, v.ja]),
)
export const SERVICE_BUY_ZH_TO_ZHTW: Record<string, string> = Object.fromEntries(
  rows.map(([zh, v]) => [zh, v.zhTW]),
)

export function translateServiceBuyNode<T>(node: T, map: Record<string, string>): T {
  if (typeof node === 'string') {
    const hit = map[node]
    const out = hit !== undefined ? hit : node
    return out as unknown as T
  }
  if (Array.isArray(node)) {
    return node.map((n) => translateServiceBuyNode(n, map)) as unknown as T
  }
  if (node !== null && typeof node === 'object') {
    const o: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(node)) {
      o[k] = translateServiceBuyNode(v, map)
    }
    return o as unknown as T
  }
  return node
}
